module.exports = __webpack_public_path__ + "9f9deeaa040ddb9b1734efa280a94895.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tag.png
// module id = 5
// module chunks = 0 1 2 3 4